<app-uni-dialog [parent]="this" [contentTemplate]="contentTemplate" [footerTemplate]="footerTemplate"></app-uni-dialog>

<ng-template #contentTemplate>
  <h3 class="mt-3">with Purchase Order: {{ destPoHeader.id }}</h3>
  <div>
    <span *ngIf="poHeaders.length == 0">
      <div class="flex flex-row">
        <div class="h3">'{{ params.manufacturer.name }}' only has a single unposted purchase order.</div>
      </div>
    </span>
    <span *ngIf="poHeaders.length > 0">
      <div class="h3 mb-8">Unposted Purchase Orders for: {{ params.manufacturer.name }}</div>
      <app-ag-grid
        gridId="combinePurchaseOrdersGrid"
        style="height: 260px"
        [gridOptions]="poGridOptions"
        [rowData]="poHeaders"
      ></app-ag-grid>
    </span>
  </div>
</ng-template>

<ng-template #footerTemplate>
  <div class="flex flex-row gap-2">
    <button id="combineOkButton" *ngIf="isPageReady && poHeaders.length > 0" (click)="ok()" [disabled]="isSaving" pButton type="button" class="p-button-raised">
      Ok
    </button>
    <button id="combineCancelButton" (click)="cancel()" pButton type="button" class="p-button-raised">Cancel</button>
  </div>
</ng-template>
